import UploadDimensionsRecommendation from './UploadDimensionsRecommendation';

export default UploadDimensionsRecommendation;
